import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-575cf28e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SidebarLogo = _resolveComponent("SidebarLogo")
  const _component_SidebarItem = _resolveComponent("SidebarItem")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")

  return (_openBlock(), _createBlock("div", {
    class: [{ 'has-logo': _ctx.showLogo }, "sideWrap"]
  }, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock(_component_SidebarLogo, {
          key: 0,
          collapse: _ctx.isCollapse
        }, null, 8, ["collapse"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
      default: _withId(() => [
        _createVNode(_component_el_menu, {
          collapse: !_ctx.isCollapse,
          "unique-opened": false,
          "default-active": _ctx.activeMenu,
          "background-color": _ctx.variables.menuBg,
          "text-color": _ctx.variables.menuText,
          "active-text-color": _ctx.menuActiveTextColor,
          mode: "vertical"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
              return (_openBlock(), _createBlock(_component_SidebarItem, {
                key: route.path,
                item: route,
                "base-path": route.path,
                "is-collapse": _ctx.isCollapse
              }, null, 8, ["item", "base-path", "is-collapse"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapse", "default-active", "background-color", "text-color", "active-text-color"])
      ]),
      _: 1
    })
  ], 2))
})